package fyi.moko.hotpl.domain.usecase

import fyi.moko.hotpl.domain.service.SocialGraphService

/** Unfriends — either member may delete the friendship doc. */
class RemoveFriendUseCase(
    private val socialGraphService: SocialGraphService,
) {
    suspend operator fun invoke(friendshipId: String) =
        socialGraphService.removeFriendship(friendshipId)
}
